const translations = {
  navigationBar: {
    'Ground Control': 'Ground Control',
    Dashboard: 'Dashboard',
    'Team Formation': 'Team Formation',
    Grading: 'Grading',
    'Game Simulator': 'Game Simulator',
    'Admin Panel': 'Admin Panel',
    Playground: 'Playground',
    'SICP JS': 'SICP JS',
    Achievements: 'Achievements',
    Quests: 'Quests',
    Paths: 'Paths',
    Contests: 'Contests',
    Others: 'Others',
  },
  dropdown: {
    'My Courses': 'My Courses',
    'Create Course': 'Create Course',
    Logout: 'Logout',
    Settings: 'Settings',
    About: 'About',
    Help: 'Help',
  },
};

export default translations;
